const routes = {
    path: 'certificados',
    name: 'Checkins_Certificados',
    component: () => import('./Certificados.vue'),
    children: [
        {
            path: 'painel',
            name: 'Checkins_Certificados_Painel',
            component: () => import('./PainelCertificados.vue'),
            meta: {
                rules: ['CHECKINS-CERTIFICADO-00'],
            },
        },
    ],
    meta: {
        rules: ['CHECKINS-CERTIFICADO-00'],
    },
};

export default routes;
